<template>
  <div :class="['opt-out-count', extraClasses]">
    <span class="member-count-with visits">{{memberCount || 0}} with</span>
    <link-toggle :linkId="countType"
                 :linkText="filterCount"
                 :openStatus="openStatus"
                 @setOpenStatus="setOpenStatus">
      <div slot="linkToggle" class="input-toggle-slot">
        <input-item :customError="inputError"
                    isOptOutInput
                    :inputId="countType"
                    inputType="number"
                    :inputValue="filterCount"
                    showErrors
                    useCustomValidation
                    zeroAllowed
                    @saveInputValue="saveFilter"
                    @customValidation="validateOptoutInput"></input-item>
      </div>
    </link-toggle>

    <div v-if="errorMessage" class="error-label text-center">{{errorMessage}}</div>
  </div>
</template>

<script>
  import InputItem from '../FormItems/InputItem'
  import LinkToggle from '../shared/LinkToggle'

  export default {
    props: {
      countType: String,
      extraClasses: String,
      memberCount: Number,
    },

    name: 'OptOutCount',

    components: {
      InputItem,
      LinkToggle,
    },

    data() {
      return {
        errorMessage: null,
        filterCount: 1,
        inputError: null,
        openStatus: false,
      }
    },

    methods: {
      getMemberCount() {
        this.$emit('reloadReport', this.countType, this.filterCount)
      },

      saveFilter(filterObject) {
        const filterKey = Object.keys(filterObject)[0],
          filterValue = filterObject[filterKey]
        this.filterCount = filterValue > -1 ? filterValue : null
        this.getMemberCount()
        this.setOpenStatus(false)
      },

      setOpenStatus(isOpen) {
        this.openStatus = isOpen
      },

      validateOptoutInput(target, inputId) {
        const value = target.value.trim(),
              parsedValue = parseInt(value),
              isWholeNumber = value % 1 === 0,
              isValid = -1 < parsedValue && parsedValue < 100000001
        if (isWholeNumber && !!value) {
          this.inputError = parsedValue < 0 ? 'must be zero or above' : parsedValue > 100000000 ? 'must be less than 100,000,000' : null
          isValid && this.saveFilter({ [inputId]: value })
        } else {
          this.inputError = 'invalid input'
        }    
      },
    },
  }
</script>